import React, { useEffect, useState } from "react";
import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import { Perspective } from "@egjs/flicking-plugins";
import { CarouselWrapper, EmptyImg, ImageContainer } from "./styles";
import Card from "./components/Card";
import usePost from "../../hooks/usePost";
import { Post } from "../../types";
import Empty from "../../../../../../assets/svg/empty.svg";
import { Result } from "antd";

const Cards: React.FC = (): JSX.Element => {
  const { postState } = usePost();

  const [items, setItems] = useState<Post[]>();
  const [isFlipped, setIsFlipped] = useState<{ [key: number]: boolean }>({});
  const [focusedIndex, setFocusedIndex] = useState<number>(0);

  const perspectivePlugin = React.useMemo(
    () =>
      new Perspective({
        rotate: -1,
        scale: 0.8,
        perspective: 600,
      }),
    []
  );

  const handleCardFlip = (index: number) => {
    if (index === focusedIndex) {
      setIsFlipped((prev) => ({ ...prev, [index]: !prev[index] }));
    }
  };

  useEffect(() => {
    if (postState.selectedSmartGoal) {
      setItems(
        postState.posts?.filter(
          (post) => post.smart_goal_id === postState.selectedSmartGoal
        )
      );
    }
  }, [postState.selectedSmartGoal, postState]);

  return (
    <CarouselWrapper>
      {postState.selectedSmartGoal ? (
        <Flicking
          circular={true}
          duration={500}
          align="center"
          plugins={[perspectivePlugin]}
          onChanged={(e) => setFocusedIndex(e.index)}
        >
          {items?.map((post, index) => (
            <div key={index}>
              <Card
                index={index}
                isFlipped={!!isFlipped[index]}
                handleCardFlip={(index) => handleCardFlip(index)}
                post={post}
              />
            </div>
          ))}
        </Flicking>
      ) : (
        <ImageContainer>
          <Result
            icon={<EmptyImg src={Empty} />}
            title="Oops!"
            subTitle="Você não possui nenhum objetivo selecionado."
          />
        </ImageContainer>
      )}
    </CarouselWrapper>
  );
};

export default Cards;
